<template lang="">
    <div class="modal fade" id="confirmMessageModal" tabindex="-1" aria-labelledby="confirmMessageModal" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="confirmMessageModal">{{ title }}</div>
        <button class="btn btn-default btn-sm close-btn" @click="closeModal">
        <CloseIcon/>
        </button>
      </div>
      <div class="modal-body">
        {{ body }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" style="color:white;background:var(--tertiary)" @click="closeModal">{{ buttonLabel || "Close" }}</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import CloseIcon from '../IconComponents/CloseIcon.vue';
export default {
  components: {
    CloseIcon
  },
    props:{
        closeModal:{
            type: Function,
            required: true            
        },
        title:{
            type: String,
            required: true
        },
        body:{
            type: String,
            required: true
        },
        buttonLabel:{
          type:String
        }
    }
}
</script>
<style scoped>

  /* MODAL */
  

   
</style>